import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CorteService } from 'src/app/services/corte.service';
import { FormatoData, FormatoService } from 'src/app/services/formato.service';

@Component({
  selector: 'app-formato-retornos',
  templateUrl: './formato-retornos.component.html',
  styleUrls: ['./formato-retornos.component.scss']
})
export class FormatoRetornosComponent implements OnInit {


    retornos: any[]=[];
    data$: Observable<FormatoData>;
    finalise = new Subject();
    consecutivo:number=0;

    constructor(
      private formatoService: FormatoService,
      private toastr: ToastrService,
      private corteService: CorteService
    ) {
      this.data$ = formatoService.obtenerData;
    }
  ngOnInit(): void {
    this.data$.pipe(takeUntil(this.finalise)).subscribe( data => {
          if ( data.tipo === 6 ) {
            this.corteService.getRetornosCorte( data.id_corte_usuario ).subscribe( retornos => {
              this.retornos = retornos;
              console.log( this.retornos );
            });
          }
          this.finalise.next();
          this.finalise.complete();
        });
  }

}
